export const ADD_FEATURE_START = 'ADD_FEATURE_START';
export const ADD_FEATURE_SUCCESS = 'ADD_FEATURE_SUCCESS';
export const ADD_FEATURE_ERROR = 'ADD_FEATURE_ERROR';
